import { EventPaymentMethod } from './payment-methods/event-payment-method.model';
import { RegistrationItem } from '../registration/shared/registration-item.model';
import { EventSignUpNotificationEmail } from './notifications/event-signup-notification-email.model';

export class EventRead {
  public constructor() {
    this.EventId = 0;
    this.StartTime = '';
    this.EndTime = '';
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.EventType = '';
    this.Descr = '';
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.Location = '';
    this.Phone = '';
    this.Email = '';
    this.RelatedWebsite = '';
    this.EventName = '';
    this.MaxAttendees = 0;
    this.Address1 = '';
    this.Address2 = '';
    this.City = '';
    this.State = '';
    this.Zip = '';
    this.ZipExt = '';
    this.OrgEvent = false;
    this.IsPublic = false;
    this.MembersOnly = false;
    this.Internal = false;
    this.ProfileId = 0;
    this.Closed = false;
    this.AssignedTo = 0;
    this.DisableRegistration = false;
    this.SendQuestionsToEmail = '';
    this.SpecialRegistrationUrl = '';
    this.ProjectId = 0;
    this.FreeEvent = false;
    this.AcceptAmex = false;
    this.AcceptMasterCard = false;
    this.AcceptVisa = false;
    this.AcceptDiscover = false;

    this.AcceptBillSignUp = false;
    this.AcceptPayAtDoor = false;
    this.AcceptCreditCard = false;
    this.AcceptPo = false;
    this.AcceptBillSignUpFee = 0;
    this.AcceptPayAtDoorFee = 0;
    this.AcceptCreditCardFee = 0;
    this.AcceptPoFee = 0;

    this.MapLink = '';
    this.WeatherLink = '';
    this.EntityId = 0;
    this.ConfirmationMessage = '';
    this.MinAttendees = 0;
    this.MinAttendeesActionDate = new Date();
    this.ImageFileName = '';
    this.ImageCaption = '';
    this.ShortDescr = '';
    this.ShowMap = false;
    this.UseOrgAddress = false;
    this.ImageUrl = '';
    this.RepeatingEventId = 0;
    this.FeaturedEvent = false;
    this.CcGatewayId = 0;
    this.ShowAttendeeDetail = false;
    this.AttendeeDetailThreshold = 0;
    this.ShowAttendees = false;
    this.ShareEnabled = false;
    this.ShareInstructions = '';
    this.Venue = '';
    this.Version = 0;

    this.RegEmailVisible = 0;
    this.RegEmailRequired = 0;
    this.RegPrefixVisible = 0;
    this.RegPrefixRequired = 0;
    this.RegFNameVisible = 0;
    this.RegFNameRequired = 0;
    this.RegLNameVisible = 0;
    this.RegLNameRequired = 0;
    this.RegNameForBadgeVisible = 0;
    this.RegNameForBadgeRequired = 0;
    this.RegCompanyNameVisible = 0;
    this.RegCompanyNameRequired = 0;
    this.RegAddressVisible = 0;
    this.RegAddressRequired = 0;
    this.RegPhoneVisible = 0;
    this.RegPhoneRequired = 0;
    this.RegMobileVisible = 0;
    this.RegMobileRequired = 0;
    this.ShowWeatherLink = false;
    this.AttendeeGoal = 0;
    this.SalesGoal = 0;
    this.RegTitleVisible = 0;
    this.RegTitleRequired = 0;
    this.Status = 0;
    this.TimeZoneId = 0;

    this.PendingAttendees = 0;
    this.AttendingAttendees = 0;
    this.PotentialAttendees = 0;
    this.SpecialDetailsPageURL = '';

    this.PaymentMethods = new Array<EventPaymentMethod>();
    this.Items = new Array<RegistrationItem>();
    this.EventSignUpNotificationEmails = new Array<EventSignUpNotificationEmail>();

    this.StartDateTimeUtc = new Date();
    this.EndDateTimeUtc = new Date();
  }
  public EventId: number;
  public StartTime: string;
  public EndTime: string;
  public StartDate: Date;
  public EndDate: Date;
  public EventType: string;
  public Descr: string;
  public DateCreated: Date;
  public DateChanged: Date;
  public Location: string;
  public Phone: string;
  public Email: string;
  public RelatedWebsite: string;
  public EventName: string;
  public MaxAttendees: number;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public ZipExt: string;
  public OrgEvent: boolean;
  public IsPublic: boolean;
  public MembersOnly: boolean;
  public Internal: boolean;
  public ProfileId: number;
  public Closed: boolean;
  public AssignedTo: number;
  public DisableRegistration: boolean;
  public SendQuestionsToEmail: string;
  public SpecialRegistrationUrl: string;
  public ProjectId: number;
  public FreeEvent: boolean;
  public AcceptAmex: boolean;
  public AcceptMasterCard: boolean;
  public AcceptVisa: boolean;
  public AcceptDiscover: boolean;

  public AcceptBillSignUp: boolean;
  public AcceptPayAtDoor: boolean;
  public AcceptCreditCard: boolean;
  public AcceptPo: boolean;
  public AcceptBillSignUpFee: number;
  public AcceptPayAtDoorFee: number;
  public AcceptCreditCardFee: number;
  public AcceptPoFee: number;

  public MapLink: string;
  public WeatherLink: string;
  public EntityId: number;
  public ConfirmationMessage: string;
  public MinAttendees: number;
  public MinAttendeesActionDate: Date;
  public ImageFileName: string;
  public ImageCaption: string;
  public ShortDescr: string;
  public ShowMap: boolean;
  public UseOrgAddress: boolean;
  public ImageUrl: string;
  public RepeatingEventId: number;
  public FeaturedEvent: boolean;
  public CcGatewayId: number;
  public ShowAttendeeDetail: boolean;
  public AttendeeDetailThreshold: number;
  public ShowAttendees: boolean;
  public ShareEnabled: boolean;
  public ShareInstructions: string;
  public Venue: string;
  public Version: number;

  public RegEmailVisible: number;
  public RegEmailRequired: number;
  public RegPrefixVisible: number;
  public RegPrefixRequired: number;
  public RegFNameVisible: number;
  public RegFNameRequired: number;
  public RegLNameVisible: number;
  public RegLNameRequired: number;
  public RegNameForBadgeVisible: number;
  public RegNameForBadgeRequired: number;
  public RegCompanyNameVisible: number;
  public RegCompanyNameRequired: number;
  public RegAddressVisible: number;
  public RegAddressRequired: number;
  public RegPhoneVisible: number;
  public RegPhoneRequired: number;
  public RegMobileVisible: number;
  public RegMobileRequired: number;
  public ShowWeatherLink: boolean;
  public AttendeeGoal: number;
  public SalesGoal: number;
  public RegTitleVisible: number;
  public RegTitleRequired: number;
  public Status: number;
  public TimeZoneId: number;

  public PendingAttendees: number;
  public AttendingAttendees: number;
  public PotentialAttendees: number;
  public SpecialDetailsPageURL: string;

  public PaymentMethods: Array<EventPaymentMethod>;
  public Items: Array<RegistrationItem>;

  public StartDateTimeUtc: Date;
  public EndDateTimeUtc: Date;
  public Instructor: string = '';
  public CourseNum: string = '';

  public EventSignUpNotificationEmails: Array<EventSignUpNotificationEmail>;
}
